import React from 'react';
import { pathway } from '../data/masterclass';
export function Pathway() {
  return <section aria-labelledby="pathway-heading" className="border-t border-ink-line bg-ink" data-id="element-101" data-mp="2ybqz4pvvds7b">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-102" data-mp="3c3fb8t64cgoa">
        <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-103" data-mp="3c4q9kdgsow80">
          The complete experience
        </p>
        <h2 id="pathway-heading" className="mt-4 font-display text-4xl font-bold uppercase text-white sm:text-5xl" data-id="element-104" data-mp="3m0juol8kxy1e">
          Three classes. One shared direction.
        </h2>

        <ol className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line sm:grid-cols-3" data-id="element-105" data-mp="3v21by6xq45ro">
          {pathway.classes.map(item => <li key={item.name} className="flex flex-col bg-ink-soft p-8" data-id="element-106" data-mp="20nqnhzl1jdmf">
              <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-107" data-mp="20pt987f5uklc">
                {item.label}
              </p>
              <h3 className="mt-3 font-display text-2xl font-semibold uppercase leading-tight text-white" data-id="element-108" data-mp="2rt7pga0ro4l2">
                {item.name}
              </h3>
              <p className="mt-auto pt-8 font-display text-xl font-bold uppercase leading-snug text-gold" data-id="element-109" data-mp="2wsalj4yrr0gw">
                {item.question}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}